export const PROTOCOL_SCHEMA = process.env.NODE_ENV === 'production' ? 'https' : 'http'
export const PORT = process.env.NODE_ENV === 'production' ? undefined : '3000'
export const BACKEND_PORT = process.env.NODE_ENV === 'production' ? undefined : '9999'
export const DOMAIN = process.env.DOMAIN

export const INTERNAL_DOMAINS = ['#', '127.0.0.1', 'localhost', `${DOMAIN}`] + DOMAIN

export const BRAND = 'Emilceramica'

export const LANGUAGES = {
  it: 'Italiano',
  en: 'English',
  de: 'Deutsch',
  fra: 'Français',
  esp: 'Español',
  us: 'English',
  es: 'Español',
  fr: 'Français',
}

export const RES_SM_MIN = 768
export const RES_MD_MIN = 992
export const WCONT_MD = 1280

export const TOOLBAR_HEIGHT = 40
export const HEADER_HEIGHT = 144
export const HEADER_HEIGHT_MOBILE = 88
export const HEADER_BREAKPOINT = RES_MD_MIN

export const itPathsFor404 = [
  '/azienda',
  '/collezioni',
  '/sostenibilita',
  '/soluzioni',
  '/progetti',
  '/contatti',
  '/rivenditori',
]
